import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';
import { Row, Col } from 'antd';
import wordmark_black from '../images/wordmark_black.png';
import SocialIcon from '../components/SocialIcon';

//Data Types
type Props = {};
//Styled Components
const StyledFooter = styled.footer`
	background-color: #fff;
	padding: 24px;
	max-width: 1200px;
	margin: 0 auto;
`;

const ConnectButton = styled.button`
	/* padding: 12px; */
	min-width: 245px;
	height: 44px;
	color: #ff254b;
	font-size: 16px;
	font-weight: 500;
	letter-spacing: 1.07px;
	line-height: 21px;
	text-align: center;
	background-color: white;
	margin: 0 auto;
	border: 3px solid #ff254b;
	border-radius: 7px;
	transition: 0.3s ease-in-out;
	margin-top: 24px;
	margin-bottom: 24px;
	:hover {
		cursor: pointer;
	}
	:focus {
		outline: 0;
	}
	:hover {
		color: white;
		background-color: #ff254b;
	}
`;
const Prompt = styled.p`
	color: #505050;
	font-size: 40px;
	font-weight: bold;
	letter-spacing: 1px;
	line-height: 62px;
	margin-bottom: 0;
`;
const Title = styled.p`
	color: #111111;
	font-size: 20px;
	font-weight: 600;
	letter-spacing: 0.81px;
`;
const Text = styled.p`
	color: #707070;
	font-size: 16px;
	font-weight: 500;
	letter-spacing: 0.67px;
`;
const HR = styled.hr`
	box-sizing: border-box;
	height: 2px;
	width: 1235px;
	border: 1px solid #ededed;
	max-width: 100%;
	margin-top: 48px;
	margin-bottom: 24px;
`;
const Lattice = styled.small`
	color: #707070;
	font-size: 16px;
	letter-spacing: 1px;
	line-height: 29px;
	text-align: center;
	font-weight: 500;
`;
//Component
const Footer: React.SFC<Props> = () => {
	let mql;
	const [ mobile, setMobile ] = useState(false);
	useEffect(() => {
		if (typeof window !== undefined) {
			mql = window.matchMedia(`(min-width: 768px)`);
			mql.addListener(mediaQueryChanged);
			mediaQueryChanged();
		}
		return () => {
			if (typeof window !== undefined) {
				mql.removeListener(mediaQueryChanged);
			}
		};
	}, []);
	const mediaQueryChanged = () => {
		if (mql.matches) {
			setMobile(false);
		} else {
			setMobile(true);
		}
	};
	return (
		<StyledFooter id='footer'>
			<Row
				style={{
					textAlign: mobile ? 'center' : undefined,
					marginBottom: '4px',
					marginTop: '48px'
				}}
				gutter={16}
			>
				<Col style={{ margin: mobile ? '24px 0' : undefined }} md={10} sm={24}>
					<Prompt style={{ maxWidth: !mobile ? '450px' : undefined }}>
						Ready to build the Next Big Thing?
					</Prompt>
					<Link title={'Connect'} to='/connect'>
						<ConnectButton>I'm Ready!</ConnectButton>
					</Link>
					<Row
						style={{
							maxWidth: !mobile ? '350px' : undefined,
							marginTop: '26px'
						}}
						type='flex'
						justify='space-between'
						align='middle'
					>
						<SocialIcon social='instagram' />
						<SocialIcon social='github' />
						<SocialIcon social='twitter' />
						<SocialIcon social='facebook' />
						<SocialIcon social='dribbble' />
					</Row>
				</Col>
				<Col style={{ margin: mobile ? '24px 0' : undefined }} md={{ span: 3, offset: 1 }} sm={24}>
					<Link title={'About'} to='/about'>
						<Title>About</Title>
					</Link>
					<Link title={'Portfolio'} to='/portfolio'>
						<Text>Portfolio</Text>
					</Link>
					<Link title={'Process'} to='/process'>
						<Text>Process</Text>
					</Link>
					<Link title={'Services'} to='/services'>
						<Text>Services</Text>
					</Link>
					<Link title={'Pricing'} to='/pricing'>
						<Text>Pricing</Text>
					</Link>
					<Link title={'Blog'} to='/blog'>
						<Text>Blog</Text>
					</Link>
				</Col>
				<Col style={{ margin: mobile ? '24px 0' : undefined }} md={{ span: 4, offset: 1 }} sm={24}>
					<a
						title={'Google Maps - Lattice Studios'}
						href='https://goo.gl/maps/uzG58U4srkvNpqFZA'
						target='_blank'
						rel='noopener'
					>
						<Title>Toronto</Title>
						<Text>#200, 140 Yonge St</Text>
						<Text>Toronto, ON</Text>
						<Text>M5C 1X6, Canada</Text>
					</a>
					<a title={'Phone - Lattice Studios'} href='tel:+4162381178' target='_blank' rel='noopener'>
						<Text>(416) 238 1178</Text>
					</a>
				</Col>
				<Col style={{ margin: mobile ? '24px 0' : undefined }} md={{ span: 4, offset: 1 }} sm={24}>
					<a
						title={'Google Maps - Lattice Studios'}
						href='https://g.page/latticestudios?share'
						target='_blank'
						rel='noopener'
					>
						<Title>Calgary</Title>
						<Text>#100, 221 10th Ave SE</Text>
						<Text>Calgary, AB</Text>
						<Text>T2G 0V9, Canada</Text>
					</a>
					<a title={'Phone - Lattice Studios'} href='tel:+14034624482' target='_blank' rel='noopener'>
						<Text>(403) 462 4482</Text>
					</a>
				</Col>
			</Row>
			<HR />
			<Row style={{ textAlign: mobile ? 'center' : undefined }} type='flex' justify='space-between'>
				<Col style={mobile ? { display: 'flex', margin: '0 auto' } : {}}>
					<Link to='/connect'>
						<img style={{ height: '40px' }} src={wordmark_black} alt='Lattice Studios' />
					</Link>
				</Col>
				<Col style={mobile ? { display: 'flex', margin: '0 auto' } : {}}>
					<Lattice>Made by Lattice Studios with Coffee and Love ✌️</Lattice>
				</Col>
			</Row>
		</StyledFooter>
	);
};

export default Footer;
